import { useSelector } from 'react-redux';

import {
  getPhoneConfirmationStatus,
  getPhoneLoadingStatus,
  getSmsCodeStatusError,
  getSmsCodeStatusTimeout,
} from '../selectors/authorization';

export function usePhoneConfirmationStatus(): string {
  return useSelector(getPhoneConfirmationStatus);
}

export function usePhoneLoadingStatus(): boolean {
  return useSelector(getPhoneLoadingStatus);
}

export function useSmsCodeStatusTimeout(): number {
  return useSelector(getSmsCodeStatusTimeout);
}

export function useSmsCodeStatusError(): string {
  return useSelector(getSmsCodeStatusError);
}
